import { createContext, useContext } from '@integrations/react'
import theme from './theme'

export type Theme = typeof theme

export const ThemeContext = createContext<Theme>(theme)

export function ThemeProvider({ children, theme: customTheme }: { children: React.ReactNode; theme?: Theme }) {
  return <ThemeContext.Provider value={customTheme ?? theme}>{children}</ThemeContext.Provider>
}

export function useTheme(): Theme {
  return useContext(ThemeContext)
}

export default ThemeContext
